<template>
  <div>
    <v-flex>
      <section>
        <v-card
          flat>
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#ff64ad"
            slider-size="5"
            show-arrows
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            dense
            grow
            class="d-flex justify-start tabs-stream">
            <v-tab
              v-for="(item, index) in list.menu"
              :key="index"
              class="px-0 mr-4 d-flex align-center">
              <v-avatar
                tile
                size="20">
                <v-img 
                  contain
                  :src="item.icon">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        size="20"
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>

              <span 
                class="body-2 text-capitalize ml-2" 
                :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item.text }}
              </span>
            </v-tab>
          </v-tabs>

          <v-card-text v-if="user.level === 'operator'"
            class="pa-0">
            <div v-if="selected.menu === 0">
              <Verification />
            </div>

            <div v-if="selected.menu === 1">
              <Account />
            </div>

            <div v-if="selected.menu === 3">
              <Request />
            </div>
          </v-card-text>

          <v-card-text v-else
            class="pa-0">
            <div v-if="selected.menu === 0">
              <Role />
            </div>

            <div v-if="selected.menu === 1">
              <Verification />
            </div>

            <div v-if="selected.menu === 2">
              <Account />
            </div>

            <div v-if="selected.menu === 3">
              <Group />
            </div>

            <div v-if="selected.menu === 4">
              <Request />
            </div>

            <div v-if="selected.menu === 5">
              <Rejected />
            </div>
          </v-card-text>
        </v-card>
      </section>
    </v-flex>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        list: {
          menu: []
        }
      }
    },
    components: {
      Role: () => import(/* webpackPrefetch: true */ '@/components/user/role.vue'),
      Verification: () => import(/* webpackPrefetch: true */ '@/components/user/verification.vue'),
      Account: () => import(/* webpackPrefetch: true */ '@/components/user/account.vue'),
      Group: () => import(/* webpackPrefetch: true */ '@/components/user/group.vue'),
      Request: () => import(/* webpackPrefetch: true */ '@/components/user/request.vue'),
      Rejected: () => import(/* webpackPrefetch: true */ '@/components/user/rejected.vue')
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    mounted () {
      if (this.user.level === 'operator') {
        this.list.menu = [
          {
            text: 'Verifikasi Akun',
            value: 'verifivation',
            icon: require('@/assets/image/user/verif.png')
          },
          {
            text: 'Terverifikasi',
            value: 'user',
            icon: require('@/assets/image/user/user.png')
          },
          {
            text: 'Perubahan Elemen',
            value: 'request',
            icon: require('@/assets/image/user/request.png')
          }
        ]

        this.selected.menu = 0
      } else {
        this.list.menu = [
          {
            text: 'Role',
            value: 'role',
            icon: require('@/assets/image/user/role.png')
          },
          {
            text: 'Verifikasi Akun',
            value: 'verifivation',
            icon: require('@/assets/image/user/verif.png')
          },
          {
            text: 'Terverifikasi',
            value: 'user',
            icon: require('@/assets/image/user/user.png')
          },
          {
            text: 'Group Petugas Registrasi',
            value: 'user',
            icon: require('@/assets/image/user/team.png')
          },
          {
            text: 'Perubahan Elemen',
            value: 'request',
            icon: require('@/assets/image/user/request.png')
          },
          {
            text: 'Penolakan',
            value: 'request',
            icon: require('@/assets/image/user/block_user.png')
          }
        ]

        this.selected.menu = this.$route.query.type === undefined ? 0 : this.$route.query.type === 'user' ? 2 : 3
      }
    },
    methods: {
      
    }
  }
</script>